var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 13.5183C9 14.0728 8.55228 14.5224 8 14.5224C7.44772 14.5224 7 14.0728 7 13.5183C7 12.9638 7.44772 12.5143 8 12.5143C8.55228 12.5143 9 12.9638 9 13.5183Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44073 5.83129C9.18004 4.87477 7.65256 4.69313 6.83498 5.43391C6.62997 5.61966 6.3138 5.60338 6.1288 5.39754C5.9438 5.1917 5.96001 4.87426 6.16502 4.6885C7.47833 3.49856 9.92089 3.78903 10.4052 5.56603C10.6411 6.42992 10.4374 7.04141 9.84804 7.7312C9.78846 7.80093 9.62924 7.97742 9.51008 8.1095C9.44544 8.18115 9.3926 8.23973 9.37384 8.2611C8.76682 8.95303 8.5 9.53891 8.5 10.5062C8.5 10.7834 8.27614 11.0082 8 11.0082C7.72386 11.0082 7.5 10.7834 7.5 10.5062C7.5 9.26662 7.86802 8.45853 8.62344 7.59745C8.648 7.56945 8.71167 7.49886 8.78503 7.41752C8.90068 7.2893 9.04043 7.13437 9.08904 7.07747C9.48108 6.61862 9.57707 6.33052 9.44073 5.83129Z",
    fill: "#757575"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16.5305C12.1421 16.5305 15.5 13.159 15.5 9.00009C15.5 4.84119 12.1421 1.46973 8 1.46973C3.85786 1.46973 0.5 4.84119 0.5 9.00009C0.5 13.159 3.85786 16.5305 8 16.5305ZM8 15.5264C4.41015 15.5264 1.5 12.6045 1.5 9.00009C1.5 5.39571 4.41015 2.47378 8 2.47378C11.5899 2.47378 14.5 5.39571 14.5 9.00009C14.5 12.6045 11.5899 15.5264 8 15.5264Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.08b30c006e01d32897bf32f3f0f84b87.svg";
export { ForwardRef as ReactComponent };